<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-02 17:23:49
 * @FilePath: \Home\Transfor-website\src\views\pc\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="homes">
      <div class="home-W">
        <div class="logo" @click="jump('#About1')">
          <div class="logo_all">
            <img src="../../assets/pc/indexpic/logo.svg" />
            <!-- <img src="../../assets/pc/Home/HomeLogo.svg" alt="" /> -->
            <!-- <div class="Home_logo">Transformers</div> -->
          </div>
        </div>
        <div class="menu">
          <ul>
            <li>
              <p @click="jump('#About')">About</p>
            </li>
            <li>
              <p @click="jump('#Mission')">Mission</p>
            </li>
            <li>
              <p @click="jump('#Service')">Service</p>
            </li>
            <li>
              <p class="pclas" @click="jump('#Stratagem')">Stratagem</p>
            </li>
            <!-- <li>
              <p @click="jump('#Team')">Team</p>
            </li> -->
            <li>
              <p @click="jump('#Contact')">Contact</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="About1">
      <!-- <div class="indexbanner"> -->
      <div class="Main-W">
        <div class="index_img">
          <img src="../../assets/pc/indexpic/uqc.gif" />
        </div>
        <!-- <div class="index_imga">
          <img src="../../assets/pc/indexpic/about.png" />
        </div>
        <div class="index_line"></div> -->
        <div class="index_uqc">
          <div class="index_uqcl">
            Based on the decentralized autonomy characteristics<br />
            of DAO to promote the development of global green
            <br />finance.
          </div>
          <div class="index_uqcr">
            <img src="../../assets/pc/indexpic/about.png" />
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div id="About">
      <div class="Main-W">
        <div class="progressall">
          <img class="aboutstop" src="../../assets/pc/indexpic/abouta.png" />
          <el-progress
            class="progress"
            :percentage="Number(percentage)"
            :color="customColor"
            :format="format"
            :stroke-width="13.2"
          ></el-progress>
        </div>
        <div class="abouts">
          <div class="abouts_l float-ud">
            Unique Capital (UQC) is a research-focused investment firm dedicated
            to <br />blockchain infrastructure. We bring together experts in the
            field of<br />
            blockchain underlying technology who share a common belief in<br />
            decentralization and the concept of decentralized autonomous<br />
            organizations (DAOs). We firmly believe that the future of
            blockchain<br />
            development relies on technology-driven solutions, and the
            importance of<br />
            infrastructure in the advancement of Web3 cannot be overstated. Our
            goal<br />
            is to support the development of decentralized infrastructure and
            related<br />
            middleware, while generating returns and fostering a continuous
            cycle of<br />
            value. We strive to make meaningful contributions to the true
            builders of <br />the Web3 ecosystem.
          </div>
          <div class="abouts_r">
            <img src="../../assets/pc/indexpic/about2.png" />
          </div>
        </div>
      </div>
    </div>
    <div id="Mission">
      <div class="Main-W">
        <div class="Mission_tit">
          <img src="../../assets/pc/indexpic/Mission.gif" />
        </div>
        <div class="Mission_cont">
          We are committed to selecting and supporting decentralized projects
          with practical use cases,<br />
          creating value for the development of the blockchain ecosystem, and
          helping them thrive.
        </div>
        <div class="Mission_img">
          <img src="../../assets/pc/indexpic/Mission1.png" />
        </div>
        <div class="Mission_box">
          <div class="Mission_boxl">
            <div class="Mission_boxls">
              <div class="boxcont">
                We are committed to growing and developing together with
                projects.<br />
                Just like the project teams, we support long-term aspirations
                and<br />
                goals.
              </div>
            </div>
            <div class="Mission_boxlx">
              <div class="boxcont">
                Our investment portfolio goes beyond infrastructure and
                middleware<br />
                protocols, encompassing diversified projects across different
                <br />domains within the blockchain ecosystem. This approach
                aims to<br />
                meet various investment needs and risk preferences, providing a
                <br />wide range of opportunities for investors.
              </div>
            </div>
          </div>
          <div class="Mission_boxr">
            <div class="Mission_boxls">
              <div class="boxcont">
                Our focus is on the value created by the projects themselves,
                and<br />
                we are dedicated to helping project teams become major drivers
                of <br />decentralized technology worldwide.
              </div>
            </div>
            <div class="Mission_boxlx">
              <div class="boxcont">
                Our team is composed of experienced cryptocurrency
                technologists<br />
                and financial experts, enabling us to blend institutional and<br />
                decentralized expertise. This allows us to provide excellent<br />
                collaborative services to high-quality projects.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Service">
      <div class="serve">
        <div class="Main-W">
          <div class="serve_tit">
            <img src="../../assets/pc/indexpic/service.png" />
          </div>
          <div class="serve_cont">
            <div class="serve_contl1">
              <img src="../../assets/pc/indexpic/server1.png" />
              <el-progress
                class="progressa"
                :percentage="Number(percentagea)"
                :color="customColor"
                :stroke-width="8"
              ></el-progress>
            </div>
            <div class="serve_contr serbox">
              We provide professional blockchain investment management services
              to our<br />
              limited partners (LPs). This includes asset allocation, risk
              management, and <br />portfolio supervision. Based on the clients'
              goals and risk tolerance, we develop<br />
              personalized investment strategies and regularly assess and adjust
              the <br />investment portfolio to achieve optimal returns and risk
              control.
            </div>
          </div>
          <div class="serve_cont">
            <div class="serve_contl2">
              <img src="../../assets/pc/indexpic/server2.png" />
              <el-progress
                class="progressb"
                :percentage="Number(percentageb)"
                :color="customColor"
                :stroke-width="8"
              ></el-progress>
            </div>
            <div class="serve_contr serboxa">
              We conduct comprehensive evaluations and due diligence on
              blockchain projects<br />
              to assess their potential and feasibility. This includes
              conducting a thorough<br />
              analysis of technical feasibility, project team, market
              competitiveness, economic<br />
              models, and other relevant aspects to make informed investment
              decisions.
            </div>
          </div>
          <div class="serve_cont">
            <div class="serve_contl3">
              <img src="../../assets/pc/indexpic/server3.png" />
              <el-progress
                class="progressc"
                :percentage="Number(percentagec)"
                :color="customColor"
                :stroke-width="8"
              ></el-progress>
            </div>
            <div class="serve_contr serboxb">
              We provide incubation and acceleration services to promising
              blockchain<br />
              startups. This includes providing financial support, technical
              assistance, <br />marketing promotion, and resource connections to
              help these startups grow<br />
              rapidly, scale their operations, and achieve their goals.
            </div>
          </div>
          <div class="serve_cont">
            <div class="serve_contl4">
              <img src="../../assets/pc/indexpic/server4.png" />
              <el-progress
                class="progressd"
                :percentage="Number(percentaged)"
                :color="customColor"
                :stroke-width="8"
              ></el-progress>
            </div>
            <div class="serve_contr serboxc">
              We conduct in-depth market research in the blockchain industry,
              providing <br />regular market insights reports and industry trend
              analysis to help our partners<br />
              gain a better understanding of industry dynamics and investment
              opportunities.<br />
              Our research team closely monitors the development and innovative
              trends in<br />
              the blockchain technology sector, offering strategic guidance to
              LPs and<br />
              partners.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Stratagem">
      <div class="Stratagem">
        <div class="Main-W">
          <div class="Stratagem_tit">
            <img src="../../assets/pc/indexpic/strategy.gif" />
          </div>
          <div class="Stratagem_box boxa float-uda">
            <img class="imga" src="../../assets/pc/indexpic/Stratagem.png" />
            <!-- <div class="imga">Technology-Driven Innovation</div> -->
            <div class="Stratagem_cont">
              The blockchain industry is a technology-driven field, and we focus
              on investing in projects that have innovative and forward-looking
              technologies. <br />This includes innovative solutions such as
              fundamental blockchain protocols, distributed applications, smart
              contracts, and privacy protection.<br />
              We closely follow technological development trends and select
              projects with the potential to disrupt the industry for
              investment.
            </div>
          </div>
          <div class="Stratagem_box boxb float-uda">
            <img class="imgb" src="../../assets/pc/indexpic/Stratagem1.png" />
            <div class="Stratagem_cont">
              We have a specific focus on vertical domains in our investments.
              Blockchain technology has vast potential across various
              industries, and we<br />
              choose to conduct in-depth research and invest in specific areas
              such as L1, ZK, DeFi, and others. By gaining a deep understanding
              of their <br />characteristics and pain points, we can select
              projects that offer solutions and achieve better investment
              returns.
            </div>
          </div>
          <div class="Stratagem_box boxc float-uda">
            <img class="imgc" src="../../assets/pc/indexpic/Stratagem2.png" />
            <div class="Stratagem_cont">
              As investors, we actively engage in and promote the development of
              the blockchain industry's ecosystem. We establish collaborative<br />
              relationships with other investment firms, incubators, technology
              providers, industry associations, and more to collectively support
              and nurture<br />
              blockchain projects. By sharing resources, experiences, and
              networks, we provide extensive support to projects and play an
              active role within the<br />
              entire ecosystem.
            </div>
          </div>
          <div class="Stratagem_box boxd float-uda">
            <img class="imgd" src="../../assets/pc/indexpic/Stratagem4.png" />
            <div class="Stratagem_cont">
              We do not place significant emphasis on the background or even the
              anonymous status of project teams. However, their execution
              capability is <br />what we are more concerned about. The success
              and implementation of blockchain projects are closely tied to the
              technical proficiency, insight, <br />and Web3 mindset of the
              team. We assess team members' experience, expertise, and cognitive
              abilities through events to ensure they have the <br />capability
              to drive project development and achieve success.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="Team">
      <div class="team">
        <div class="Main-W">
          <div class="team_tit">
            <img src="../../assets/pc/indexpic/team.png" />
          </div>
          <div class="team_box">
            <div class="team_li">
              <div class="team_img">
                <img src="../../assets/pc/indexpic/team1.png" />
              </div>
              <div class="team_tita">milaoshu</div>
              <div class="team_titb">milaoshu</div>
            </div>
            <div class="team_li">
              <div class="team_img">
                <img src="../../assets/pc/indexpic/team1.png" />
              </div>
              <div class="team_tita">milaoshu</div>
              <div class="team_titb">milaoshu</div>
            </div>
            <div class="team_li">
              <div class="team_img">
                <img src="../../assets/pc/indexpic/team1.png" />
              </div>
              <div class="team_tita">milaoshu</div>
              <div class="team_titb">milaoshu</div>
            </div>
            <div class="team_li">
              <div class="team_img">
                <img src="../../assets/pc/indexpic/team1.png" />
              </div>
              <div class="team_tita">milaoshu</div>
              <div class="team_titb">milaoshu</div>
            </div>
            <div class="team_li">
              <div class="team_img">
                <img src="../../assets/pc/indexpic/team1.png" />
              </div>
              <div class="team_tita">milaoshu</div>
              <div class="team_titb">milaoshu</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div id="Contact" class="Mains Contact">
      <div class="Main-W">
        <div class="Contact_tit">
          <img src="../../assets/pc/indexpic/contact.png" />
        </div>
        <div class="Contact_cont">
          Please provide us with more information about your project, and we
          will get back to you promptly with specific ideas on how to support<br />
          your organizational processes and achieve project outcomes.
        </div>
        <div class="Contact_from">
          <el-form ref="form" :model="form" :rules="rules">
            <div class="Contact_name">
              <div class="Contact_li">
                <el-form-item prop="fullName">
                  <el-input
                    v-model="form.fullName"
                    placeholder="Full name"
                    class="inpttext"
                    @input="getInfo"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="Contact_li">
                <el-form-item prop="email">
                  <el-input
                    v-model="form.email"
                    placeholder="E-mail"
                    class="inpttext"
                    @input="getInfo"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="Information">
              <el-form-item prop="content">
                <el-input
                  type="textarea"
                  v-model="form.content"
                  placeholder="Information"
                  class="textall"
                  @input="getInfo"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </div>
            <div class="submits" v-if="!btnShow">
              <img src="../../assets/pc/indexpic/submit.png" />
            </div>
            <div
              class="submitsa"
              id="submits"
              v-if="btnShow"
              @click="submitForm"
            >
              <img src="../../assets/pc/indexpic/submita.png" />
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- <div class="swiper_banner">
      <div class="Main-W">
        <div class="swiper-container">
          <div
            class="swiper-wrapper"
            :style="{ flexDirection: `${vertical ? 'column' : 'row'}` }"
          >
      
            <div
              class="swiper-slide"
              :style="[
                {
                  transform: `${
                    animate
                      ? vertical
                        ? 'translateY(-50%)'
                        : 'translateX(-50%)'
                      : 'none'
                  }`,
                },
                { transition: `${animate ? 'all 1.5s' : 'none'}` },
              ]"
              v-for="(item, index) in list1"
              :key="index"
            >
             
              <img :class="item.name" :src="item.ImgUrl" />
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { goPAGE } from "@/utils/utils";
import { GetcommitApply } from "@/assets/server/api.js";
const echarts = require("echarts");
export default {
  props: {
    duration: {
      //滚动时长
      type: Number,
      default: 4000,
    },
    vertical: {
      //是否纵向
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IMgUrl: "",
      W: document.body.clientWidth + "px",
      list1: [
        { ImgUrl: require("@/assets/pc/indexpic/foot1.png"), name: "img" },
        { ImgUrl: require("@/assets/pc/indexpic/foot2.png"), name: "img1" },
        { ImgUrl: require("@/assets/pc/indexpic/foot3.png"), name: "img2" },
        { ImgUrl: require("@/assets/pc/indexpic/foot4.png"), name: "img3" },
        { ImgUrl: require("@/assets/pc/indexpic/foot5.png"), name: "img4" },
        { ImgUrl: require("@/assets/pc/indexpic/foot6.png"), name: "img5" },
      ],
      timer: null,
      animate: false,
      list: [
        {
          name: "About",
        },
        {
          name: "Mission",
        },
        {
          name: "Service",
        },
        {
          name: "Stratagem",
        },
        {
          name: "Team",
        },
        {
          name: "Contact",
        },
      ],
      id: "", //设置下拉框是否显示
      clientId: "", //设置wallet页面导航栏颜射
      borId: "",
      index: 0,
      form: {
        content: "", //介绍
        fullName: "",
        email: "",
      },
      rules: {
        // 第一部分效验开始
        fullName: [
          {
            required: true,
            message: "This field is required.",
            trigger: "blur",
          },
          { min: 1, max: 10, message: " Less than 50 bytes", trigger: "blur" },
        ],

        email: [
          {
            required: true,
            type: "email",
            message: "Please fill this in email",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: " Less than 100 bytes",
            trigger: "blur",
          },
        ],

        content: [
          {
            required: true,
            message: "This field is required.",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: " Less than 1000 bytes",
            trigger: "blur",
          },
        ],

        // 第一部分效验结束
      },
      widthPre: "",
      percentage: 10,
      percentagea: 10,
      percentageb: 10,
      percentagec: 10,
      percentaged: 10,
      customColor: "#0B27F1",
      btnShow: false,
    };
  },
  components: {},
  // 计算属性

  created() {
    this.timer = setInterval(this.scroll, this.duration);
  },
  mounted() {
    window.addEventListener("scroll", this.scrollFn, false);
    //     const isLight = window.matchMedia('(prefers-color-scheme: light)').matches;
    // const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

    // console.log(isLight);
    // console.log(isDarkMode);
    // console.log();
    //     window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (event) => {
    //         if (event.matches) {
    //           //dark mode
    //           console.log("黑夜模式");
    //         } else {
    //           //light mode
    //           console.log("白天模式");
    //         }
    //       });
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        const newColorScheme = e.matches ? "dark" : "light";
        console.log(newColorScheme);
      });
    // window.addEventListener("scroll", this.scrollFna, false);
  },
  destroyed() {},
  methods: {
    getInfo() {
     // console.log(this.form.Name.length);

      if (
        this.form.fullName.length >= 1 &&
        this.form.email.length >= 1 &&
        this.form.content.length >= 1
      ) {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
    },
    format(percentage) {
      return percentage === 100 ? "100%" : `${percentage}%`;
    },
    scrollFn() {
      let page = document.body.scrollHeight;
      let client = document.documentElement.clientHeight;
      let comend = page - client;
      let scrTop = document.documentElement.scrollTop;
      this.percentage = Number(Math.round((scrTop / comend) * 10000) / 10);
      if (this.percentage > 100) {
        this.percentage = 100;
      }
      this.percentagea =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 280;
      this.percentageb =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 290;
      this.percentagec =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 300;
      this.percentaged =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 310;

      if (this.percentagea >= 100) {
        this.percentagea = 100;
      } else if (this.percentagea <= 0) {
        this.percentagea = 10;
      }

      if (this.percentageb >= 100) {
        this.percentageb = 100;
      } else if (this.percentageb <= 0) {
        this.percentageb = 10;
      }
      if (this.percentagec >= 100) {
        this.percentagec = 100;
      } else if (this.percentagec <= 0) {
        this.percentagec = 10;
      }
      if (this.percentaged >= 100) {
        this.percentaged = 100;
      } else if (this.percentaged <= 0) {
        this.percentaged = 10;
      }
    },
    jump(id) {
      this.shows1 = false;
      var height = document.body.clientHeight;

      var aa = document.querySelector(id);
      // aa.style.backgroundColor="red";
      setTimeout(function () {
        document.querySelector(id).scrollIntoView(true);
      }, 500);
      aa.scrollTo(0, height);
      document.querySelector(id).scrollIntoView(true);
      document.querySelector(id).scrollIntoView();
    },
    Home() {
      this.Scolor = "";
      this.$router.push("/pc/Index");
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        this.list.push(this.list.shift()); //删除数组的第一个元素并添加到数组的最后一项
        this.animate = false; //滑动完成后取消过渡动画，实现无缝滚动
      }, this.duration / 2); //滑动item项必须要在每次轮播开始前,所以时间必须比duration短
    },
    async submitForm() {
      this.$refs.form.validate(async (success) => {
        if (success) {
          this.ImgUrl = this.ImgUrla;
          let formData = new FormData();
          let item = this.form;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetcommitApply(formData);
          if (data.code == 200) {
            this.$message("Thank you for submitting the form!");
            this.$refs.form.resetFields();
            this.btnShow = false;
          } else {
            this.$message("This field is required");
          }
        } else {
          this.$message("Out of byte range or This field are not filled in ");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.el-input__inner,
.el-textarea__inner {
  height: 28px;
  font-size: 24px;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #000000;

  line-height: 28px;
}
.el-textarea__inner {
  padding-top: 24px;
}
.el-progress__text {
  display: none;
}

.el-progress {
  position: relative;
  width: 80px;
  left: 303px;
  top: -72px;
  background: none;
}
.el-progress-bar__outer {
  background: none !important;
}
.progress ::v-deep.el-progress-bar__outer {
  border-radius: 24px 24px 24px 24px;
  border: none;
  // width: 268px;
  width: 350px;
  height: 14px;

  background: none !important;
  opacity: 1;
}
@media (prefers-color-scheme: dark) {
  background: #fff;
}
.homes {
  width: 100%;
  background: #fff;
  z-index: 10;

  position: fixed;
}
.home-W {
  width: 1320px;
  height: 64px;
  margin: 0 auto;
  display: flex;
  background: #fff;
  .logo {
    flex: 0 0 40%;
    padding: 16px 0;
    .logo_all {
      width: 190px;
      display: flex;
      cursor: pointer;
      .Home_logo {
        flex: 0 0 75%;
      }
      img {
        flex: 0 0 25%;
        width: 86px;
        height: 35px;
        margin-right: 10px;
      }

      line-height: 28px;
    }
  }
  .menu {
    flex: 0 0 60%;
    ul {
      display: flex;
      li {
        flex: 1;
        font-size: 16px;
        font-family: Poppins-Medium, Poppins;
        color: rgba(0, 0, 0, 0.800000011920929);
        cursor: pointer;
        padding: 20px 0 0 0;
        p {
          //  border: 1px solid red;
          width: 115px;
          height: 24px;
          text-align: right;
          line-height: 24px;
          font-family: Poppins-Medium, Poppins, "Segoe UI", "Roboto", "Oxygen",
            "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
            sans-serif;
          font-weight: 650;
          // i {
          //   margin-left: 8px;
          // }
        }
        .pclas {
          margin-left: 18px;
        }
      }
    }
  }
}

.Home {
  width: 410px;
  padding-bottom: 10px;
  display: inline-block;
  font-size: 16px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 530;
  color: rgba(255, 255, 255, 0.6000000238418579);
  border-bottom: 1px solid #4d4d4d;
  padding-left: 10px;
}
.active {
  transition: all 0.5s;
  height: 225px;
  box-shadow: 0px 113px 100px 1px rgba(0, 0, 0, 0.4000000059604645);
}
.actives:hover {
  p {
    color: #cd60d9 !important;
  }
  .iconfont {
    display: inline-block;
    transition: all 0.5s;
    transform: rotate(180deg) !important ;
  }
}

.swiper_banner {
  width: 100%;
  background: #fff;
  padding-top: 325px;
  .Main-W {
    width: 1320px;
    margin: 0 auto;
    background: #fff;
    .swiper-container {
      width: 100%;
      height: 91px;
      overflow: hidden;
      margin-bottom: 142px;
      .swiper-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        .swiper-slide {
          width: 275px;
          height: 91px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 50px;
          // img{
          //   width: 275px;
          //   // height: 91px;
          // }
          .img {
            width: 275px;
            height: 91px;
            // margin-left: 100px;
          }
          .img1 {
            width: 272px;
            height: 53px;
          }
          .img2 {
            width: 312px;
            height: 47px;
          }
          .img3 {
            width: 272px;
            height: 65px;
          }
          .img4 {
            width: 60px;
            height: 65px;
            margin-left: 100px;
            margin-right: 100px;
          }
          .img5 {
            width: 186px;
            height: 66px;
          }
        }
      }
    }
  }
}

#About1 {
  background: #fff;
  width: 100%;
  height: 1008px;
  margin: 0 auto;
  .Main-W {
    width: 1320px;
    margin: 0 auto;
    background: #fff;
    .index_img {
      // height: 206px;
      width: 100%;
      padding-top: 164px;
      img {
        width: 1317px;
        height: 320px;
      }
    }

    .index_line {
      width: 1320px;
      height: 8px;
      background: #000000;
      border-radius: 250px 250px 250px 250px;
      opacity: 1;
      margin-top: 23px;
    }
    .index_uqc {
      display: flex;
      padding-top: 145px;
      .index_uqcl {
        width: 861px;
        height: 150px;
        font-size: 30px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #333333;
        line-height: 50px;
        text-align: left;
      }

      .index_uqcr {
        margin-left: 338px;
        margin-top: 112px;
        img {
          width: 125px;
          height: 28px;
        }
      }
    }
  }
}
#About {
  padding-top: 191px;
  background: #fff;
  width: 100%;
  height: 1026px;
  .Main-W {
    width: 1320px;
    margin: 0 auto;
    background: #fff;
    .progressall {
      .aboutstop {
        // width: 732px;
        height: 118px;
        margin-right: 588px;
        opacity: 1;
      }
      .progress {
        width: 350px;
        height: 20px;
        // border: 1px solid red;
      }
    }
    .abouts {
      display: flex;
      margin-top: 119px;
      justify-content: space-between;
      .abouts_l {
        width: 652px;
        height: 440px;
        font-size: 18px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }
      .float-ud {
        animation: float 2s;
      }

      @keyframes float {
        0% {
          transform: translateY(140px);
          opacity: 0;
        }
        // 50% {
        //   transform: translateY(-70px);
        // }
        100% {
          transform: translateY(0px);
          opacity: 1;
        }
      }
      .abouts_r {
        //margin-top: 78px;
        img {
          margin-top: 14px;
          width: 97px;
          height: 405px;
        }
      }
    }
  }
}
#Mission {
  background: #2f47ee;
  width: 100%;
  // height: 1080px;

  .Main-W {
    width: 1320px;
    background: #2f47ee;
    margin: 0 auto;
    padding-bottom: 128px;
    .Mission_tit {
      padding-top: 128px;
      margin-left: 284px;
      img {
        width: 752px;
        height: 102px;
        margin: 0 auto;
      }
    }
    .Mission_cont {
      width: 1030px;
      height: 80px;
      font-size: 20px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #ffffff;
      line-height: 28px;
      margin-left: 209px;
      // margin: 0 auto;
      margin-top: 20px;
      text-align: left;
    }
    .Mission_img {
      margin-top: 115px;
      margin-left: 412px;
      img {
        width: 558px;
        height: 59px;
      }
    }
    .Mission_box {
      display: flex;
      justify-content: space-between;
      margin-top: 25px;
      // padding-bottom: 100px;
      .Mission_boxl {
        width: 650px;
        .Mission_boxls {
          width: 650px;
          height: 136px;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          border: 6px solid #ffffff;
          .boxcont {
            margin: 14px 9px 24px 24px;
            font-size: 18px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #ffffff;
            line-height: 32px;
            text-align: left;
          }
        }
        .Mission_boxls:hover,
        .Mission_boxlx:hover {
          background: #ff00ff;
          border: 6px solid #ffa2ff;

         
        }
        .Mission_boxlx {
          margin-top: 30px;
          width: 645px;
          height: 210px;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          border: 6px solid #ffffff;
          .boxcont {
            margin: 24px 9px 24px 24px;
            font-size: 18px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #ffffff;
            line-height: 32px;
            text-align: left;
          }
        }
      }
      .Mission_boxr {
        width: 645px;
        .Mission_boxls {
          width: 645px;
          height: 136px;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          border: 6px solid #ffffff;
          .boxcont {
            margin: 14px 9px 24px 24px;
            font-size: 18px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #ffffff;
            line-height: 32px;
            text-align: left;
          }
        }
        .Mission_boxlx {
          margin-top: 30px;
          width: 645px;
          height: 210px;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          border: 6px solid #ffffff;
          .boxcont {
            margin: 14px 9px 24px 24px;
            font-size: 18px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #ffffff;
            line-height: 32px;
            text-align: left;
          }
        }
        .Mission_boxls:hover,
        .Mission_boxlx:hover {
          background: #ff00ff;
          border: 6px solid #ffa2ff;

        
        }
      }
    }
  }
}
#Service {
  background: #fff;
  width: 100%;
  height: 1580px;
  .serve {
    width: 100%;
    background: #fff;
    .Main-W {
      width: 1320px;
      margin: 0 auto;
      .serve_tit {
        padding-top: 200px;
        margin-bottom: 138px;
        margin-left: 416px;
        img {
          width: 494px;
          height: 113px;
          //  border: 1px solid red;
        }
      }
      .serve_cont {
        display: flex;
        justify-content: space-between;
        .serve_contl1 {
          // border: 1px solid red;
          // margin-top: 51px;
          img {
            width: 270px;
            height: 92px;
            margin-top: 32px;
          }
          .progressa {
            position: relative;
            left: 240px;
            top: -80px;
            // width: 54px !important;
          }
        }

        .serve_contl2 {
          img {
            margin-top: 24px;
            width: 345px;
            height: 91px;
          }
          .progressb {
            position: relative;
            left: 350px;
            top: -30px;
          }
        }
        .serve_contl3 {
          // margin-top: 51px;
          img {
            width: 309px;
            height: 91px;
            margin-top: 24px;
          }
          .progressc {
            position: relative;
            left: 280px;
            top: -20px;
          }
        }
        .serve_contl4 {
          // margin-top: 31px;
          img {
            width: 309px;
            height: 91px;
            margin-top: 52px;
          }
          .progressd {
            position: relative;
            left: 230px;
            top: -28px;
          }
        }
        .serbox {
          height: 160px;
          margin-bottom: 100px;
        }
        .serboxa {
          height: 128px;
          margin-bottom: 100px;
        }
        .serboxb {
          height: 128px;
          margin-bottom: 100px;
        }
        .serboxc {
          height: 192px;
        }
        .serve_contr {
          // margin-left: 300px;
          text-align: left;
          width: 697px;

          font-size: 18px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #333333;
          word-spacing: -1px;
          line-height: 32px;
          // border: 1px solid red;
        }
      }
    }
  }
}
#Stratagem {
  background: #2f47ee;
  width: 100%;
  // height: 1724px;
  .Stratagem {
    width: 100%;
    background: #2f47ee;
    .Main-W {
      width: 1320px;
      background: #2f47ee;
      margin: 0 auto;
      padding-bottom: 128px;
      .Stratagem_tit {
        padding-top: 103px;
        margin-left: 396px;
        img {
          width: 613px;
          height: 128px;
        }
      }
      .boxa {
        height: 234px;
      }
      .boxb {
        height: 223px;
      }
      .boxc {
        height: 265px;
      }
      .boxd {
        height: 266px;
      }
      .float-uda {
        animation: floata 3s ease;
      }

      @keyframes floata {
        0% {
          transform: translateX(300px);
          opacity: 0;
        }
        // 50% {
        //   transform: translateX(200px);
        // }
        100% {
          transform: translateX(0px);
          opacity: 1;
        }
      }

      .Stratagem_box {
        margin-top: 48px;
        width: 1320px;
        // height: 285px;
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        border: 6px solid #ffffff;
        // border: 1px solid red;
        .imga {
          // width: 593px;
          height: 43px;
          font-size: 40px;
          
          font-weight: 700;
          color: #ffffff;
          line-height: 60px;
          margin-top: 34px;
          
          margin-left: 34px;
        }
        .imgb {
          width: 421px;
          height: 32px;
          margin-top: 30px;
          margin-left: 34px;
        }
        .imgc {
          width: 474px;
          height: 42px;
          margin-top: 34px;
          margin-left: 34px;
          margin-right: 765px;
        }
        .imgd {
          width: 527px;
          height: 43px;
          // height: 60px;
          margin-top: 34px;
          margin-left: 34px;
          margin-right: 372px;
        }
        .Stratagem_cont {
          width: 1257px;
          height: 128px;
          font-size: 18px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 32px;
          margin-top: 20px;
          text-align: left;
          margin-left: 34px;
          word-spacing: -1px;
         
        }
      }
      .Stratagem_box:hover {
        background: #ff00ff;
        border: 6px solid #ffa2ff;
        font-size: 18px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 32px;
        // word-spacing: -3px;
        // img:hover {
        //   margin-left: 20px;
        // }
        // .Stratagem_cont:hover {
        //   margin-left: 20px;
        //   width: 1280px;
        //   font-size: 18px;
        //   font-family: Roboto-Bold, Roboto;
        //   font-weight: 700;
        //   color: #ffffff;
        //   line-height: 32px;
        //   word-spacing: -3px;
        // }
      }
    }
  }
}
#Team {
  background: #fff;
  width: 100%;
  height: 1520px;
  .team {
    width: 100%;
    .Main-W {
      width: 1320px;
      margin: 0 auto;
      .team_tit {
        padding-top: 200px;
        margin-bottom: 135px;
        margin-left: 472px;
        img {
          width: 367px;
          height: 117px;
        }
      }
      .team_box {
        display: flex;
        flex-wrap: wrap;
        .team_li {
          width: 400px;
          height: 400px;
          background: #2f47ee;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          border: 0px solid #000000;
          margin-right: 40px;
          margin-bottom: 180px;
          position: relative;
          .team_img {
            img {
              // width: 43px;
              height: 357px;
              position: absolute;
              right: 0;
            }
          }
          .team_tita {
            position: absolute;
            width: 190px;
            height: 32px;
            font-size: 36px;
            font-family: Poppins-SemiBold, Poppins;
            font-weight: 600;
            color: #000000;
            line-height: 32px;
            letter-spacing: 1px;
            bottom: -60px;
            left: 116px;
          }
          .team_titb {
            position: absolute;
            width: 126px;
            height: 32px;
            font-size: 24px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            bottom: -100px;
            left: 141px;
          }
        }
        .team_li:nth-child(4) {
          margin-left: 230px;
        }
      }
    }
  }
}
.Contact {
  background: #fff;
  // height: 1175px;
  height: 1200px;
  padding-top: 240px;
  .Main-W {
    width: 1320px;
    margin: 0 auto;
    padding: 0;
    .Contact_tit {
      img {
        width: 653px;
        height: 94px;
      }
    }
    .Contact_cont {
      margin-top: 20px;
      width: 1319px;
      height: 120px;
      font-size: 20px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
    }
    .Contact_from {
      margin-top: 80px;
      // padding-bottom: 80px;
      .Contact_name {
        display: flex;
        .Contact_li {
          width: 300px;
          height: 76px;
          line-height: 76px;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          border: 3px solid #333333;
          input {
            border: none;
            height: 69px;
            border-radius: 20px 20px 20px 20px;
            opacity: 1;

            // height: 74px;
          }
        }
        .Contact_li:nth-child(1) {
          margin-left: 333px;
          margin-right: 40px;
        }
      }
      .Information {
        width: 640px;
        height: 377px;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        border: 3px solid #333333;
        margin-left: 333px;
        margin-top: 40px;
        textarea {
          border: none;
          height: 369px;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
        }
      }
      .submits {
        width: 640px;
        height: 85px;
        width: 640px;
        border: 6px solid #000000;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        margin-left: 333px;
        margin-top: 40px;
        font-size: 30px;
        line-height: 85px;
        text-align: center;
        img {
          width: 130px;
          height: 29px;
          margin-top: 24px;
        }
      }
      .submitsa {
        width: 640px;
        height: 85px;
        background: #2f47ee;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        margin-left: 333px;
        margin-top: 40px;
        font-size: 30px;
        line-height: 85px;
        text-align: center;
        img {
          width: 130px;
          height: 29px;
          margin-top: 28px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
